<pcg-resizable-widget showFacility="true">
    <span widget-title>Inventory Cycle Counts</span>
    <div class="h-100" widget-body>
        @if (fetching() || !hasBeenInitialized()) {
            <div
                class="mt-2 pb-1 text-center"
                aria-live="polite"
            >
                <span
                    class="spinner-border spinner-border-sm align-middle mr-1"
                    aria-hidden="true"
                ></span>
                Finding In Progress Cycle Counts...
            </div>
        } @else {
            @for (cycleCount of cycleCounts(); track cycleCount.cycleCountId) {
                <pcg-link
                    [href]="getReconUrl(cycleCount)"
                    [hideStyling]="true"
                >
                    <div class="cc-item d-flex flex-wrap align-items-center justify-content-between">
                        <div class="d-flex flex-column align-items-start">
                            <div class="d-flex flex-row">
                                <span
                                    >{{ cycleCount.inventoryName }} |
                                    {{ cycleCount.reconciliationType | enumToDescription: typeEnum }}</span
                                >
                            </div>
                            <small
                                class="text-muted"
                                appendTo="body"
                                pTooltip="Created {{ cycleCount.dateCreated | date: 'medium' }}"
                            >
                                {{ cycleCount.dateCreated | utcToLocal | timeAgo }}
                            </small>
                        </div>

                        <div class="d-flex flex-column align-items-start">
                            <span [class]="getStatusColor(cycleCount.status) + ' d-flex align-text-top'">
                                {{ cycleCount.status | enumToDescription: statusEnum }}
                                <i [class]="'ml-1 pi ' + getStatusIcon(cycleCount.status)"></i>
                            </span>
                        </div>
                    </div>
                </pcg-link>
            } @empty {
                <div class="text-center text-muted py-3">No in progress Cycle Counts</div>
            }
        }
    </div>
</pcg-resizable-widget>